import { PAGE_LEVEL } from '@/constants';

/**
 * 问答模块
 */
export default {
  meta: { localeModules: ['question', 'aiChat', 'cloudDocument', 'report', 'summary'] },
  // 问答
  path: '/question',
  redirect: '/question/list',
  children: [
    {
      path: 'list',
      name: 'questionList',
      component: () => import(/* webpackChunkName: 'market-research-question' */ '@/pages/marketResearch/question.vue'),
      meta: {
        name: 'routers.question_question',
        componentName: 'QuestionListIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        keepAlive: true
      }
    }
  ]
};
